mutation licenseStockPhoto($input: LicenseStockPhotoInput!) {
  licenseStockPhoto(input: $input) {
    url
    license
    isLicensed
  }
}
